<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear absolute color="success" height="4" indeterminate></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="stock-color" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <v-form ref="departmentForm" v-model="validForm" @submit.prevent>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="requestData.name"
                      :label="$t('GENERAL.LABELS.NAME') + '*'"
                      :rules="[validations.required()]"
                      :error-messages="validationErrors.name || []"
                      @change="clearValidationError('name')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-checkbox
                      v-model="requestData.is_active"
                      class="mt-0 mt-md-5"
                      :label="$t('GENERAL.LABELS.ACTIVE')"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="back">
                {{ $t("GENERAL.LABELS.BACK_BUTTON") }}
              </v-btn>
              <v-btn color="success" @click="store">
                {{ actionText }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import validations from "@/views/partials/form/Validations.vue";
import userStateService from "@/common/userState.service";
import { SHOW_SNACK } from "@/store/snack.module";
import {
  CREATE_STOCK_PRODUCT_DEPARTMENT,
  GET_STOCK_PRODUCT_DEPARTMENT,
  UPDATE_STOCK_PRODUCT_DEPARTMENT,
} from "@/store/stock/stockProductDepartments.module";

export default {
  name: "StockEditProductDepartment",
  data() {
    return {
      validations,
      tab: "tab-1",
      isProcessing: false,
      validForm: false,
      validationErrors: {},
      title: this.$t("STOCK.PRODUCT_DEPARTMENTS.CREATE"),
      actionText: this.$t("GENERAL.LABELS.CREATE_BUTTON"),
      requestData: {
        name: "",
        is_active: true,
      },
    };
  },
  mounted() {
    this.loadDepartment();
  },
  methods: {
    getErrorMessage(error) {
      if (error && error.errors && typeof error.errors === "object") {
        const firstErrorField = Object.keys(error.errors)[0];
        const firstErrorList = error.errors[firstErrorField];
        if (Array.isArray(firstErrorList) && firstErrorList.length) {
          return firstErrorList[0];
        }
      }
      return error?.message || this.$t("GENERAL.UNEXPECTED_ERROR");
    },
    clearValidationError(field) {
      if (this.validationErrors[field]) {
        this.$delete(this.validationErrors, field);
      }
    },
    loadDepartment() {
      if (!this.$route.params.id) {
        return;
      }

      this.title = this.$t("STOCK.PRODUCT_DEPARTMENTS.EDIT");
      this.actionText = this.$t("GENERAL.LABELS.EDIT_BUTTON");
      this.isProcessing = true;

      return this.$store
        .dispatch(GET_STOCK_PRODUCT_DEPARTMENT, this.$route.params.id)
        .then((response) => {
          this.requestData = {
            name: response.name || "",
            is_active: !!response.is_active,
          };
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    back() {
      this.$router.push({ name: "stock-product-departments" });
    },
    store() {
      this.$refs.departmentForm.validate();
      if (!this.validForm) {
        return;
      }

      this.validationErrors = {};
      let action = CREATE_STOCK_PRODUCT_DEPARTMENT;
      let payload = this.requestData;

      if (this.$route.params.id) {
        action = UPDATE_STOCK_PRODUCT_DEPARTMENT;
        payload = {
          id: this.$route.params.id,
          params: this.requestData,
        };
      }

      this.isProcessing = true;
      this.$store
        .dispatch(action, payload)
        .then((response) => {
          const blinkId = response?.id || this.$route.params.id;
          if (blinkId) {
            userStateService.setState(
              "table-state.stock-product-departments-table.blinkRowItemKey",
              blinkId
            );
          }
          this.$store.dispatch(SHOW_SNACK, { message: this.$t("GENERAL.SUCCESS_MESSAGE") });
          this.$router.push({ name: "stock-product-departments" });
        })
        .catch((error) => {
          this.validationErrors = error?.errors || {};
          this.$store.dispatch(SHOW_SNACK, {
            message: this.getErrorMessage(error),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
